import { render, staticRenderFns } from "./BindUser.vue?vue&type=template&id=47c8d395&scoped=true&"
import script from "./BindUser.vue?vue&type=script&lang=js&"
export * from "./BindUser.vue?vue&type=script&lang=js&"
import style0 from "./BindUser.vue?vue&type=style&index=0&id=47c8d395&scoped=true&lang=css&"
import style1 from "./BindUser.vue?vue&type=style&index=1&id=47c8d395&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8d395",
  null
  
)

export default component.exports